import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./conditional-popup.${locale}.json`));
